const seatStyles = {
  active: "border-[#D4AF37]/40 bg-[#D4AF37]/12 text-[#F6F1E9]",
  pending: "border-white/12 bg-white/6 text-[#F6F1E9]",
  available: "border-white/10 bg-[#171717] text-[#B8B0A5]",
};

export const AmbassadorSeatLedger = ({ foundingMembership }) => {
  const seats = foundingMembership?.seat_ledger || [];

  return (
    <div className="rounded-[32px] border border-[#D4AF37]/18 bg-[linear-gradient(160deg,#1A1A1A_0%,#202020_58%,#27231E_100%)] p-6 text-[#F6F1E9] shadow-[0_20px_60px_rgba(22,18,11,0.2)]" data-testid="founding-seat-ledger">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#D4AF37]">Founding 18 Seat Ledger</p>
          <h2 className="mt-3 font-[Cormorant_Garamond,serif] text-4xl font-bold leading-none text-[#F6F1E9]">One active founder. The rest are still being claimed.</h2>
        </div>
        <div className="rounded-full border border-[#D4AF37]/26 bg-white/5 px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-[#D4AF37]" data-testid="founding-seat-ledger-summary-pill">
          {foundingMembership?.active_count ?? 1} active • {foundingMembership?.pending_count ?? 5} pending • {foundingMembership?.available_count ?? 12} available
        </div>
      </div>

      <div className="mt-6 grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {seats.map((seat) => (
          <div className={`rounded-[24px] border p-4 ${seatStyles[seat.status] || seatStyles.available}`} data-testid={`founding-seat-ledger-seat-${seat.slot}`} key={seat.slot}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#D4AF37]">Seat {seat.slot}</p>
                <p className="mt-3 text-lg font-semibold text-inherit">{seat.name}</p>
              </div>
              <span className="rounded-full border border-current/20 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em]" data-testid={`founding-seat-ledger-seat-status-${seat.slot}`}>
                {seat.label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};